import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allProducts } from 'app/mocks/data/catalogue/products'
import { allAllergens } from 'app/mocks/data/catalogue/products/allergens'
import { allProductCategories } from 'app/mocks/data/catalogue/products/categories'
import { allSubcategories } from 'app/mocks/data/catalogue/products/subcategories'
import { allSuppliers } from 'app/mocks/data/catalogue/suppliers'
import { allManagers } from 'app/mocks/data/park/managers'

import { formDataToData } from 'app/utils/app/requests'
import { api, assets } from 'app/utils/constants'

import { Product, ProductPayload } from 'app/types/catalogue/product'

export const updateProduct = http.patch(
    `${process.env.REACT_APP_API_ADDRESS}/${api.catalogue.products.DETAILS}`,
    async ({ request, params }) => {
        const data = await request.formData()
        const { id } = params

        const payload = formDataToData(data)

        const payloadParsed = ProductPayload.safeParse(payload)

        const productFound = allProducts.find(
            (product) => product.id.toString() === id,
        )

        // Not found
        if (!productFound) {
            return new HttpResponse(null, {
                status: StatusCodes.NOT_FOUND,
            })
        }

        // Wrong data
        if (!payloadParsed.success) {
            return new HttpResponse(null, {
                status: StatusCodes.UNPROCESSABLE_ENTITY,
            })
        }

        return HttpResponse.json<Product>({
            ...payloadParsed.data,
            photo: assets.ethik.KONSOLE_COLOR,
            category: allProductCategories.find(
                (category) => category.id === payloadParsed.data.category,
            ),
            client: allManagers.find(
                (manager) => payloadParsed.data.client === manager.id,
            ),
            supplier: allSuppliers.find(
                (supplier) => payloadParsed.data.supplier === supplier.id,
            ),
            subcategory: allSubcategories.find(
                (subcategory) =>
                    payloadParsed.data.subcategory === subcategory.id,
            ),
            allergens: allAllergens.filter((allergen) =>
                payloadParsed.data.allergens.includes(allergen.id),
            ),
        })
    },
)
